import React from 'react';
import PropTypes from 'prop-types';
import { FormattedMessage } from 'react-intl';
import { Row, Col, FormGroup, Label, Input } from 'reactstrap';
import { Tooltip, Icon } from 'antd'

import messages from './messages';
import 'antComponentsStyle';
import './fields.scss';

class CustomerFields extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      contractualCategorySelected: props.values.employee_category || null,
      showInput: {
        pi: false,
        rs: false
      }
    }
  }

  handleOnContractualCategoryChange = (event) => {
    const selectedMapped = this.props.contractualeCateogries.find(category => category.value === event.target.value)
    this.setState({
      contractualCategorySelected: event.target.value,
      showInput: selectedMapped.requiredData
    })
    this.props.callback(event);
  }

  get isBusinessCategory() {
    const { contractualCategorySelected } = this.state;

    if (contractualCategorySelected) {
      const selectedMapped = this.props.contractualeCateogries.find(category => category.value === contractualCategorySelected)
      return selectedMapped.type === 'BUSINESS';
    }

    return false;
  }

  get fiscalCodeLabel() {
    return this.isBusinessCategory ? messages.fiscalCodeBusiness.defaultMessage : messages.fiscalCode.defaultMessage;
  }

  render() {
    const { contractualeCateogries, values, errors, callback } = this.props;
    const size = 3;
    return (
      <div className={'CustomerFields'}>
        <Row className={'no-gutters'}>
          <Col md={size} xs={12}>
            <FormGroup>
            <Label for="firstName" className="required">
              <FormattedMessage {...messages.firstName}/>
            </Label>
            <Input
              type="text"
              name="first_name"
              id="firstName"
              placeholder={'Mario'}
              value={values.first_name}
              onChange={callback}
              invalid={errors.has('first_name')}
              required
            />
            </FormGroup>
          </Col>
          <Col md={size} xs={12}>
            <FormGroup>
            <Label for="lastName" className="required">
              <FormattedMessage {...messages.lastName}/>
            </Label>
            <Input
              type="text"
              name="last_name"
              id="lastName"
              placeholder={'Rossi'}
              value={values.last_name}
              onChange={callback}
              invalid={errors.has('last_name')}
              required
            />
            </FormGroup>
          </Col>
          <Col md={3} xs={12}>
            <FormGroup>
            <Label for="email" className="required">
              <FormattedMessage {...messages.email}/>
            </Label>
            <Input
              type="email"
              name="email"
              id="email"
              placeholder={'mario@rossi.it'}
              value={values.email}
              onChange={callback}
              invalid={errors.has('email')}
              required
            />
            </FormGroup>
          </Col>
          <Col md={3} xs={12}>
            <FormGroup>
            <Label for="phone" className="required">
              <FormattedMessage {...messages.phone}/>
            </Label>
            <Input
              type="text"
              name="phone"
              id="phone"
              placeholder={'Telefono'}
              value={values.phone}
              onChange={callback}
              invalid={errors.has('phone')}
              required
            />
            </FormGroup>
          </Col>
        </Row>
        <Row className={'no-gutters'}>
          <Col md={3} xs={12}>
            <FormGroup>
            <Label for="address" className="required">
              <FormattedMessage {...messages.address}/>
            </Label>
            <Input
              type="text"
              name="address"
              id="address"
              placeholder={'Indirizzo'}
              value={values.address}
              onChange={callback}
              invalid={errors.has('address')}
              required
            />
            </FormGroup>
          </Col>
          <Col md={1} xs={12}>
            <FormGroup>
            <Label for="postalCode" className="required">
              <FormattedMessage {...messages.postalCode}/>
            </Label>
            <Input
              type="text"
              name="zip_code"
              id="postalCode"
              placeholder={'Cap'}
              value={values.zip_code}
              onChange={callback}
              invalid={errors.has('zip_code')}
              required
            />
            </FormGroup>
          </Col>
          <Col md={3} xs={12}>
            <FormGroup>
            <Label for="contractualCategory" className="required">
              <FormattedMessage {...messages.contractualCategory}/>
            </Label>
            <Input
              type="select"
              name="employee_category"
              id="contractualCategory"
              value={values.employee_category}
              onChange={this.handleOnContractualCategoryChange}
              required
            >
              {
                contractualeCateogries.map(item => (
                  <option
                    key={item.value}
                    value={item.value}
                    data-employeetype={item.type}
                    data-secondaryemployeetype={item.secondaryType}
                  >
                    {item.description}
                  </option>
                ))
              }
            </Input>
            </FormGroup>
          </Col>
          <Col md={5} xs={12}>
            <FormGroup>
            <Label for="fiscalCode" className="required">
              <span>{this.fiscalCodeLabel}</span>
            </Label>
            {this.isBusinessCategory &&
              <Tooltip title={<FormattedMessage {...messages.fiscalCodeTooltip} />}>
                <Icon type="question-circle-o" />
              </Tooltip>
            }
            <Input
              type="text"
              name="fiscal_code"
              id="fiscalCode"
              placeholder={this.fiscalCodeLabel}
              value={values.fiscal_code}
              onChange={callback}
              invalid={errors.has('fiscal_code')}
              required
            />
            </FormGroup>
          </Col>
        </Row>
        <Row className={'no-gutters'}>
          <Col md={6} xs={12} {...this.state.showInput.pi ? null : {hidden: true}}>
            <FormGroup>
            <Label for="vatNumber" className="required">
              <FormattedMessage {...messages.vatNumber}/>
            </Label>
            <Input
              type="text"
              name="vat_number"
              id="vatNumber"
              placeholder={'14570951005'}
              value={values.vat_number}
              onChange={callback}
              invalid={errors.has('fiscal_code')}
              required
            />
            </FormGroup>
          </Col>
          <Col md={6} xs={12} {...this.state.showInput.rs ? null : {hidden: true}}>
            <FormGroup>
            <Label for="businessName" className="required">
              <FormattedMessage {...messages.businessName}/>
            </Label>
            <Input
              type="text"
              name="business_name"
              id="businessName"
              placeholder={'iDEAL'}
              value={values.business_name}
              onChange={callback}
              required
            />
            </FormGroup>
          </Col>
        </Row>
      </div>
    );
  }
}

CustomerFields.defaultProps = {};

CustomerFields.propTypes = {
  values: PropTypes.object.isRequired,
  errors: PropTypes.any.isRequired,
  contractualeCateogries: PropTypes.any.isRequired,
  callback: PropTypes.func.isRequired,
};
export default CustomerFields;
